import { SVGProps } from 'react';
const SvgTrashEmpty = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M18 6H6v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V6ZM4 6h16M15 3H9a1 1 0 0 0-1 1v2h8V4a1 1 0 0 0-1-1Z"
    />
  </svg>
);
export default SvgTrashEmpty;
